module.exports = __webpack_public_path__ + "img/search.e5052513.svg";